<template>
  <div class="flex justify-center">
    <div class="m-4 space-y-4 p-6 md:w-1/2">
      <div class="space-y-6 text-center">
        <OutlineInformationCircleIcon class="mx-auto h-20 w-20 text-gray-300" />
        <p class="text-2xl font-bold text-gray-300">{{ msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: { type: String, default: 'Sin datos para mostrar' },
  },
}
</script>
